'use strict';
const _ = require('lodash');
const Backbone = require('backbone');
const PubSub = require('../PubSub');
const template = require('../templates/confirm.ejs');

module.exports = Backbone.View.extend({
    tagName: 'div',
    className: 'view-confirm',
    events: {
        'click .btn-edit': 'close',
        'click .btn-submit': 'submitVotes'
    },
    /**
     * Initialize View
     */
    initialize: function (options) {
        _.bindAll(this, 'render');
        this.copy = options.copy;
    },
    /**
     * Render View
     */
    render: function () {
        var headline = this.copy.headline.replace('{{TOTAL}}', this.model.get('totalAllocatedVotes'));
        this.$el.html(template({
            headline: headline,
            submitText: this.copy.submit_text,
            editText: this.copy.edit_text
        }));
        return this;
    },
    /**
     * Submit Votes
     */
    submitVotes: function(e) {
        e.preventDefault();
        if(!this.model.get('totalAllocatedVotes')) {
            return false;
        }
        
        e.currentTarget.setAttribute('disabled', 'disabled');
        
        var data = {
            categoryID: this.model.get('id'),
            categoryName: this.model.get('name'),
            categoryVoteData: this.model.get('categoryVotes'),
            totalAllocatedVotes: this.model.get('totalAllocatedVotes')
        };
        PubSub.trigger('submitVotes', data);
    },
    /**
     * Close Modal
     */
    close: function(e) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        PubSub.trigger('directRoute', 'closeCurrentModal');
    }
});


// WEBPACK FOOTER //
// ./app/scripts/views/confirm.js